// extracted by mini-css-extract-plugin
export var growableInput = "_7b-0";
export var tagContainer = "_7b-2";
export var textInput = "_7b-1";